import * as React from 'react';
import { IconProps } from './IconProps';

const InfoIcon = ({ size = '16' }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#A7A7B1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6665 12.0003C6.6665 12.7367 7.26346 13.3337 7.99984 13.3337C8.73622 13.3337 9.33317 12.7367 9.33317 12.0003V8.00032C9.33317 7.26394 8.73622 6.66699 7.99984 6.66699C7.26346 6.66699 6.6665 7.26395 6.6665 8.00033V12.0003Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6665 4.00033C6.6665 4.73671 7.26346 5.33366 7.99984 5.33366C8.73622 5.33366 9.33317 4.73671 9.33317 4.00033C9.33317 3.26395 8.73622 2.66699 7.99984 2.66699C7.26346 2.66699 6.6665 3.26395 6.6665 4.00033Z"
      fill="white"
    />
  </svg>
);

export default InfoIcon;
